import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Tag, Currency } from '@teko/ui';

const Table = styled.table`
  width: 100%;
  td {
    line-height: 1;
  }
`;
const Line = styled.td(({ color, first, align }) => `
    color: ${color};
    padding: 0;
    padding-top: ${first ? "0px" : "0.85rem"};
    text-align: ${align};
    vertical-align: top;
  `);
const Price = styled.td(({ first }) => `
    font-weight: 700;
    font-size: 14px;
    padding: 0;
    text-align: right;
    padding-top: ${first ? "0px" : "0.85rem"};
    vertical-align: top;
  `);
const FinalPrice = styled.td`
  color: #eb2101;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  text-align: right;
  vertical-align: bottom;
  padding: 0;
`;
const Text = styled.div`
  font-size: 14px;
  color: #848788;
  margin-top: 4px;
  text-align: center;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const Divider = styled.div`
  width: 100%;
  border: 1px dashed #e4e5f0;
  height: 2px;
  margin-top: 15px;
`;
const Invoices = ({
  invoices,
  align = "left",
  textColor = "#848788",
  vat,
  className,
  hideShippingFee,
  infoText
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement("tbody", null, invoices.map(({ text, price, notFormat, tag, separator }, index) => /* @__PURE__ */ React.createElement(React.Fragment, null, separator && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", {
    colSpan: 2
  }, /* @__PURE__ */ React.createElement(Divider, null))), /* @__PURE__ */ React.createElement("tr", {
    key: index
  }, /* @__PURE__ */ React.createElement(Line, {
    color: textColor,
    first: !index,
    align
  }, text, " ", !!tag && /* @__PURE__ */ React.createElement(Tag, {
    variant: "primary",
    outline: true
  }, tag)), index !== invoices.length - 1 ? /* @__PURE__ */ React.createElement(Price, {
    first: !index
  }, notFormat ? price : /* @__PURE__ */ React.createElement(Currency, {
    value: price,
    space: true,
    underline: true
  })) : /* @__PURE__ */ React.createElement(FinalPrice, null, /* @__PURE__ */ React.createElement(Currency, {
    value: price,
    space: true
  }))))))), vat && /* @__PURE__ */ React.createElement(Text, null, t("(\u0110\xE3 bao g\u1ED3m VAT{{var0}})", {
    var0: hideShippingFee ? ", Chi\u1EBFt Kh\u1EA5u v\xE0 ph\xED giao h\xE0ng n\u1EBFu c\xF3" : ""
  })), !vat && hideShippingFee && /* @__PURE__ */ React.createElement(Text, null, t("(\u0110\xE3 bao g\u1ED3m ph\xED giao h\xE0ng)")), !!infoText && /* @__PURE__ */ React.createElement(Text, null, infoText));
};

export { Invoices };
